import { isIOS, isAndroid } from "react-device-detect";

const cleverTapName = "my_com_myboost";

/**
 * CleverTap for webview android & ios pushEvent
 *
 * For more information, see the [CleverTap Webview documentation](https://developer.clevertap.com/docs/webview).
 *
 * @component
 * @param {String} eventName - The name of the CleverTap event handler.
 * @param {Object} props - The props data to be sent to CleverTap.
 * @returns {void} This function does not return a value.
 *
 * @example
 * // Example usage of pushEvent
 * pushEvent("BAU_CLICK", {name: "John", id: "1234"})
 */
const pushEvent = (eventName, props) => {
  if (isAndroid && window[cleverTapName]) {
    window[cleverTapName].pushEvent(eventName, JSON.stringify(props));
  }

  if (isIOS && window.webkit?.messageHandlers?.[cleverTapName]) {
    const message = { action: "recordEventWithProps", event: eventName, properties: props };

    window.webkit.messageHandlers[cleverTapName].postMessage(message);
  }
};

const clevertapWebview = {
  pushEvent
};

export default clevertapWebview;
